
export default {
  artisans: [],
  fullNameArtisans: [],
  artisans_with_interventions: []

}
